import { css } from "@emotion/react";

export const field = css`
  margin-bottom: 0.25rem;
`;
